import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostSurvey2024/layout/Component/FormTitle';
import FormInput from '@src/mobile/phtvHostSurvey2024/layout/Component/FormInput';
import FormSelect from '@src/mobile/phtvHostSurvey2024/layout/Component/FormSelect';
// import { countryNameList } from './country';

const Required = ({ formData, setFormDataHandle, warningTextList }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.onlineSignUp}>
            <div className={styles.formList}>
                <div className={styles.formListBox}>
                    <FormTitle name="name" title="姓名" warningText={warningTextList['name']} isRequired={true} />
                    <FormInput name="name" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="gender" title="性別" warningText={warningTextList['gender']} isRequired={true} />
                    <FormSelect
                        name="gender"
                        formData={formData}
                        changeInputHandle={changeInputHandle}
                        optionValueList={['男', '女']}
                    />
                    <FormTitle title="年齡" name="age" warningText={warningTextList['age']} isRequired={true} />
                    <FormInput name="age" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle
                        title="畢業院校"
                        name="current_college"
                        warningText={warningTextList['current_college']}
                        isRequired={true}
                    />
                    <FormInput name="current_college" placeholder="XX大學XX學院" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="major" title="專業" warningText={warningTextList['major']} isRequired={true} />
                    <FormInput name="major" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="job" title="職業" warningText={warningTextList['job']} isRequired={true} />
                    <FormInput name="job" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="location" title="常駐地" warningText={warningTextList['location']} isRequired={true} />
                    <FormInput name="location" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle
                        name="contact_details"
                        title="聯系方式"
                        warningText={warningTextList['contact_details']}
                        isRequired={true}
                    />
                    <FormInput
                        name="contact_details"
                        formData={formData}
                        placeholder="手機號"
                        changeInputHandle={changeInputHandle}
                    />
                </div>
            </div>
        </div>
    );
};

Required.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
};

export default errorBoundary(Required);
